import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ViewWorkforceLayer from "../components/ViewWorkforceLayer";


const ViewWorkForcePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="View Workforce" />

        {/* AddUserLayer */}
        <ViewWorkforceLayer />


      </MasterLayout>
    </>
  );
};

export default ViewWorkForcePage;
